/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Container, Slide1, Slide2 } from './styles';

import lotus from '~/assets/tv/botox/lotus.svg';
import botox from '~/assets/tv/botox/botox.svg';
import woman from '~/assets/tv/botox/woman.png';
import beforeAfter1 from '~/assets/tv/botox/before-after-1.png';
import beforeAfter2 from '~/assets/tv/botox/before-after-2.png';

interface IBotox {
  show: boolean;
  startAnim: boolean;
}

interface ISlide {
  slide: string;
  slideTime: number;
  beforeTime?: number;
  afterTime?: number;
  bgSlide?: string;
}

const Botox: React.FC<IBotox> = ({ show, startAnim }) => {
  const [slideSelected, setSlideSelected] = useState({} as ISlide);
  const [showBefore, setShowBefore] = useState('');
  const [animSlideSelected, setAnimSlideSelected] = useState('');
  const [endAnimSlideSelected, setEndAnimSlideSelected] = useState('');

  const slides = useMemo<ISlide[]>(
    () => [
      {
        slide: 'Slide1',
        slideTime: 7500,
      },
      { slide: 'Slide2', slideTime: 7500 },
    ],
    []
  );

  const changeSlide = useCallback(
    (index) => {
      const { slide, slideTime } = slides[index];

      if (slides[index + 1] && slides[index + 1].beforeTime) {
        const nextSlide = slides[index + 1];
        if (nextSlide.beforeTime)
          setTimeout(() => {
            setShowBefore(nextSlide.slide);
            setAnimSlideSelected(nextSlide.slide);
          }, slideTime - nextSlide.beforeTime);
      }

      if (slides[index - 1] && slides[index - 1].afterTime) {
        const prevSlide = slides[index - 1];
        if (prevSlide.afterTime) {
          setEndAnimSlideSelected(prevSlide.slide);
          setSlideSelected(slides[index]);
          setTimeout(() => {
            setShowBefore('');
            setEndAnimSlideSelected('');
          }, prevSlide.afterTime);
        }
      } else {
        setSlideSelected(slides[index]);
      }

      setTimeout(() => {
        setAnimSlideSelected(slide);
        if (index + 1 < slides.length) {
          setTimeout(() => {
            changeSlide(index + 1);
          }, slideTime);
        }
      }, 100);
    },
    [slides]
  );

  useEffect(() => {
    if (show) {
      changeSlide(0);
    }
  }, [changeSlide, show]);

  return (
    <Container show={show} startAnim={startAnim}>
      <Slide1
        show={slideSelected.slide === 'Slide1'}
        startAnim={slideSelected.slide === 'Slide1'}
      >
        <div className="slide-container">
          <img src={lotus} alt="Coi logo" className="lotus" />
          <img src={botox} alt="Botox®" className="botox" />
          <img src={woman} alt="woman" className="woman" />
          <h2>
            Botox
            <i>Day</i>
          </h2>
          <div className="content">
            <p>de</p>
            <p className="brown">R$35 unidade</p>
            <p>
              por <span className="brown">R$14 unidade</span>
            </p>
          </div>
          <p className="date">12 de junho</p>
        </div>
      </Slide1>
      <Slide2
        show={slideSelected.slide === 'Slide2'}
        startAnim={slideSelected.slide === 'Slide2'}
      >
        <div className="slide-container">
          <img src={botox} alt="botox" className="botox" />
          <h2>Botox previne o envelhecimento</h2>
          <p className="content">Veja os resultados -{'>'}</p>
          <p className="models">Precisamos de pacientes modelos</p>
          <img src={beforeAfter1} alt="beforeAfter1" className="beforeAfter1" />
          <img src={beforeAfter2} alt="beforeAfter2" className="beforeAfter2" />
        </div>
      </Slide2>
    </Container>
  );
};

export default Botox;
